import { t } from "ttag";

import { Button, Flex, Text } from "metabase/ui";

type MetricEmptyStateProps = {
  isRunnable: boolean;
  runQuestionQuery: () => void;
};

export function MetricEmptyState({
  isRunnable,
  runQuestionQuery,
}: MetricEmptyStateProps) {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      mih="100%"
      data-testid="metric-empty-state"
    >
    </Flex>
  );
}
